import { render, staticRenderFns } from "./PurposeDetail.vue?vue&type=template&id=467a8b01"
import script from "./PurposeDetail.vue?vue&type=script&lang=ts"
export * from "./PurposeDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports